import React, { useState } from 'react'
import { css } from '@emotion/react'
import Image from '../base-ui/Image'
import { Link } from '../base-ui'
import { IoCloseSharp } from 'react-icons/io5'
import useBreakpoints from '../../hooks/useBreakpoints'

function StickyAd({
    imageSrc,
    href,
    title,
    orientation = 'horizontal',
    style,
    width = 170,
    height = 230,
}) {
    const [visible, setVisible] = useState(true)
    const breakpoint = useBreakpoints({ xs: false })
    return (
        <div
            className='dasdsadasds'
            css={css`
                position: fixed;
                display: ${visible === true ? 'block' : 'none'};
                bottom: 50px;
                right: 10px;
                border: 1px solid #ff9aa6;
                height: ${orientation === 'vertical' ? height + 'px' : '100px'};
                width: ${orientation === 'vertical' ? width + 'px' : '300px'};
                ${orientation !== 'vertical' && breakpoint.xs && 'width: 95%'};
                border-radius: 10px;
                z-index: 99;
                border-bottom-right-radius: 0;
                .body {
                    flex-direction: ${orientation === 'vertical'
                    ? 'column'
                    : 'row'};
                    .adImage {
                        width: ${orientation === 'vertical' ? '100%' : '100px'};
                        padding: ${orientation !== 'vertical'
                    ? '0.25rem'
                    : '0'};
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        img {
                            border-bottom-right-radius: ${orientation !==
                    'vertical'
                    ? '0'
                    : false};
                        }
                    }
                    .adClick {
                        margin: 0.25rem auto;
                        padding: 0.125rem 0.5rem;
                        background-color: #ef233c;
                        border-radius: 0.25rem;
                        font-size: 0.8rem;
                        color: #fff;
                        min-width: 70px;
                    }
                }
                box-shadow: 0 3.1px 5.4px rgba(0, 0, 0, 0.057),
                    0 10.3px 18.1px rgba(0, 0, 0, 0.083),
                    0 46px 81px rgba(0, 0, 0, 0.14);
            `}
            style={style}
        >
            <button
                css={buttonStyles}
                onClick={() => {
                    setVisible(false)
                }}
            >
                <span className="text">بستن</span>
                <IoCloseSharp />
            </button>
            <Link
                href={href}
                style={{
                    display: 'block',
                    height: '100%',
                }}
            >
                <div className="relative w-full h-full flex body bg-white rounded-lg">
                    {imageSrc && <div className="order-1 adImage">
                        <Image
                            noStyle
                            src={imageSrc}
                            alt="picture"
                            width={orientation === 'vertical' ? width : 100}
                            height={
                                orientation === 'vertical' ? height / 2 : 100
                            }
                            objectFit="cover"
                            className="rounded-lg"
                        />
                    </div>}
                    <div
                        className="h-full bg-white flex order-2 adText"
                        css={css`
                            border-bottom-left-radius: 10px;
                            border-top-left-radius: ${orientation === 'vertical'
                                ? 0
                                : '10px'};
                            opacity: 95%;
                            z-index: 99;
                            padding: 2px 5px;
                            overflow: hidden;
                            width: ${orientation === 'vertical' || !imageSrc
                                ? '100%'
                                : '70%'};
                            gap: ${orientation === 'vertical' || !imageSrc
                                ? '1rem'
                                : '0.5rem'};
                            flex-direction: column;
                            align-items: center;
                            justify-content: center;
                        `}
                    >
                        <div
                            style={{
                                fontSize: '0.85rem',
                                lineHeight: '1.15rem',
                                textAlign: 'right',
                                overflow: 'hidden',
                                display: '-webkit-box',
                                WebkitBoxOrient: 'vertical',
                                WebkitLineClamp: 3,
                            }}
                        >
                            {title}
                        </div>
                        <div className="adClick">کلیک کنید</div>
                    </div>
                </div>
            </Link>
        </div>
    )
}

export default StickyAd

const buttonStyles = css`
    position: absolute;
    display: flex;
    top: -25px;
    border-radius: 4px;
    left: 0;
    font-size: 1.5rem;
    z-index: 999;
    color: #ef233c;
    .text {
        font-size: 0.8rem;
    }
    background-color: #ffffffe0;
    padding-right: 0.25rem;
`